import { render, staticRenderFns } from "./StocksPage.vue?vue&type=template&id=b912cff4&scoped=true&"
import script from "./StocksPage.vue?vue&type=script&lang=js&"
export * from "./StocksPage.vue?vue&type=script&lang=js&"
import style0 from "./StocksPage.vue?vue&type=style&index=0&id=b912cff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b912cff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b912cff4')) {
      api.createRecord('b912cff4', component.options)
    } else {
      api.reload('b912cff4', component.options)
    }
    module.hot.accept("./StocksPage.vue?vue&type=template&id=b912cff4&scoped=true&", function () {
      api.rerender('b912cff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/StocksPage.vue"
export default component.exports